import { useMemo } from 'react';
import { marked } from 'marked';
import hljs from 'highlight.js/lib/common';

marked.use({
  gfm: true,
  breaks: false,
  renderer: {
    code(token: { text: string; lang?: string }): string {
      const lang = (token.lang ?? '').trim();
      let highlighted: string;
      try {
        highlighted = lang
          ? hljs.highlight(token.text, { language: lang, ignoreIllegals: true }).value
          : hljs.highlightAuto(token.text).value;
      } catch {
        highlighted = escapeHtml(token.text);
      }
      const langClass = lang ? `language-${lang}` : '';
      return `<pre><code class="hljs ${langClass}">${highlighted}</code></pre>`;
    },
  },
});

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]!));
}

export function Markdown({ source }: { source: string }): JSX.Element {
  const html = useMemo(() => marked.parse(source) as string, [source]);
  return <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />;
}
